import { Pipe, PipeTransform } from '@angular/core';

import { DeviceState } from '@app/store/device.model';

@Pipe({ name: 'deviceStateClass' })
export class DeviceStateClassPipe implements PipeTransform {
  static cmap = new Map<DeviceState, string>([
    [DeviceState.NO_FIRMWARE, 'danger'],
    [DeviceState.FAULT, 'danger'],
    [DeviceState.FAULT_REACTION_ACTIVE, 'danger'],
    [DeviceState.INCOMPATIBLE_FIRMWARE, 'warning'],
    [DeviceState.NOT_CONFIGURED, 'warning'],
    [DeviceState.WARNING, 'warning'],
    [DeviceState.CONNECTED, 'success'],
  ]);

  transform(deviceState: DeviceState): string {
    return DeviceStateClassPipe.cmap.get(deviceState);
  }
}
